export default __webpack_public_path__ + "static/media/logo-zalo.dca5f814.png";